import { z } from "zod";

export const feedbackSchema = z.object({
  rate: z.number().int().min(1).max(5),
  details: z.string().max(2000).default(""),
  websiteId: z.string().min(1),
  applicationId: z.string().min(1),
});

export const trustpilotInvitationSchema = z.object({
  applicationId: z.string().min(1),
  redirectURI: z.string().min(1),
});

export const trustpilotReviewCollectorSchema = z.object({
  applicationId: z.string().min(1),
  domain: z.string().min(1),
});
